export let WalletsErrorCode;

(function (WalletsErrorCode) {
  WalletsErrorCode[WalletsErrorCode["UNKNOWN"] = 0] = "UNKNOWN";
  WalletsErrorCode[WalletsErrorCode["TIMEOUT"] = 1] = "TIMEOUT";
  WalletsErrorCode[WalletsErrorCode["CANCELLED"] = 2] = "CANCELLED";
  WalletsErrorCode[WalletsErrorCode["MISSING_ARGUMENTS"] = 3] = "MISSING_ARGUMENTS";
  WalletsErrorCode[WalletsErrorCode["HW_WRONG_APP"] = 4] = "HW_WRONG_APP";
  WalletsErrorCode[WalletsErrorCode["HW_U2F_NOT_SUPPORTED"] = 5] = "HW_U2F_NOT_SUPPORTED";
  WalletsErrorCode[WalletsErrorCode["HW_IFRAME_BLOCKED"] = 6] = "HW_IFRAME_BLOCKED";
  WalletsErrorCode[WalletsErrorCode["HW_POPUP_BLOCKED"] = 7] = "HW_POPUP_BLOCKED";
})(WalletsErrorCode || (WalletsErrorCode = {}));

export class WalletsError extends Error {
  constructor(message, errorCode, originalError) {
    super(message);
    this.name = 'WalletsError';
    this.errorCode = errorCode;
    this.originalError = originalError;
  }

}
//# sourceMappingURL=errors.js.map